import type { InferredScopeLocation } from '../useInferScopeLocation';

export type DmiSkipReason = 'not_local' | 'locality_unresolved' | 'unsupported_country' | 'dedup';

/**
 * Why DMI would or wouldn't fire for this submit (CHANGE-98274), for the `sap_dmi_eligibility`
 * tracking call — `null` means it fires. `existingInference` (a reused, not freshly-resolved,
 * result) always means dedup, regardless of what it contains, since a cached location is the same
 * input DMI would receive anyway.
 */
export function resolveDmiSkipReason(
	existingInference: InferredScopeLocation | null,
	inferredScopeLocation: InferredScopeLocation | null,
	supportedCountries: readonly string[],
): DmiSkipReason | null {
	if (existingInference) return 'dedup';
	if (inferredScopeLocation?.scope !== 'LOCAL') return 'not_local';
	if (!inferredScopeLocation.city || !inferredScopeLocation.adminArea) return 'locality_unresolved';
	if (!inferredScopeLocation.countryCode || !supportedCountries.includes(inferredScopeLocation.countryCode)) {
		return 'unsupported_country';
	}
	return null;
}
